import config from '../../config'

import {useAppDispatch} from '../../hooks/redux'
import {closeModal, openContactFormModal} from '../../redux/features/modal'

import copyToClipboard from '../../../../commons/src/services/copy-to-clipboard'

import {ContactModalOption, ModalMeta} from '../../types'

import emailIcon from '../../../../commons/src/assets/icons/email.svg'
import fileNoteIcon from '../../../../commons/src/assets/icons/file-note.svg'

import ContactOptionButton from '../../../../commons/src/components/contact-option-button'
import Headline from '../../../../commons/src/components/headline'
import Modal from '../../../../commons/src/components/modal'
import Paragraph from '../../../../commons/src/components/paragraph'

type Props = {
  meta: ModalMeta
  contactOptions: ContactModalOption[]
}

const ContactModal = ({meta, contactOptions}: Props) => {
  const dispatch = useAppDispatch()
  const isOptionEnabled = (option: ContactModalOption) =>
    !contactOptions || contactOptions.includes(option)

  return (
    <Modal
      fullscreenMobile={meta.fullscreenMobile}
      headline={<Headline label="What can we do for you?" size="l" />}
      onClose={() => dispatch(closeModal())}
    >
      <Paragraph minor>
        We’re available during business hours on email and by contact form. You can also request a
        missing material or give us feedback. No issue is too big or small, so don’t hesitate to get
        in touch!
      </Paragraph>
      {isOptionEnabled('email') && (
        <ContactOptionButton
          as="a"
          href={`mailto:${config.emails.partner}`}
          target="_blank"
          onClick={() => {
            copyToClipboard(config.emails.partner)
            dispatch(closeModal())
          }}
          className="u-margin-bottom-s"
          icon={emailIcon}
        >
          Copy <strong>Email</strong> to contact us at {config.emails.partner}
        </ContactOptionButton>
      )}
      {isOptionEnabled('form') && (
        <ContactOptionButton
          className="u-margin-bottom-s"
          icon={fileNoteIcon}
          onClick={() => dispatch(openContactFormModal())}
        >
          Use our <strong>contact form</strong>
        </ContactOptionButton>
      )}
    </Modal>
  )
}
export default ContactModal
